import Vue from 'vue'
import Router from 'vue-router'
import main from '@/components/main/main'
// import storeMain from '@/components/main/storeMain'
import storeMain from '@/components/main/storeMain2'
import searchMain from '@/components/main/searchMain'
import selectApp from '@/components/selectApp/selectApp'
import detailProduct from '@/components/detailProduct/detailProduct'
import productBasket from '@/components/productBasket/productBasket'
import paymentCard from '@/components/productBasket/paymentCard'
import prePay from '@/components/prePay/prePay'
import orderProcessList from '@/components/orderProcessList/orderProcessList'
import chat from '@/components/chat/chat'
import privacy1 from '@/components/privacy/privacy1'
import privacy2 from '@/components/privacy/privacy2'
import privacy4 from '@/components/privacy/privacy4'
import versionCheck from '@/components/versionCheck.vue'
import wishList from '@/components/wishList/wishList'
import sery from '@/components/tutorial/sery'
Vue.use(Router)

const routes = [
  {
    path: '/seq/:seq',
    name: 'main',
    component: main,
    meta: {
      keepAlive: true // Cache required
    }
    // children: [{}]
  },
  {
    path: '/storeMain',
    name: 'storeMain',
    component: storeMain,
    meta: {
      keepAlive: true // Cache required
    }
  },
  {
    path: '/',
    name: 'searchmain',
    redirect: '/searchMain',
    meta: {
      keepAlive: false // Cache required
    }
  },
  {
    path: '/searchMain',
    name: 'searchMain',
    component: searchMain,
    meta: {
      keepAlive: false // Cache required
    }
  },
  {
    path: '/selectApp',
    name: 'selectApp',
    component: selectApp,
    meta: {
      keepAlive: false // Cache required
    }
  },
  {
    path: '/detailProduct',
    name: 'detailProduct',
    component: detailProduct,
    meta: {
      keepAlive: true // Cache required
    }
  },
  {
    path: '/productBasket',
    name: 'productBasket',
    component: productBasket,
    meta: {
      keepAlive: false // Cache required
    }
  },
  {
    path: '/paymentCard',
    name: 'paymentCard',
    component: paymentCard,
    meta: {
      keepAlive: false // Cache required
    }
  },
  {
    path: '/prePay',
    name: 'prePay',
    component: prePay,
    meta: {
      keepAlive: false // Cache required
    }
  },
  {
    path: '/orderProcessList',
    name: 'orderProcessList',
    component: orderProcessList,
    meta: {
      keepAlive: true // Cache required
    }
  },
  {
    path: '/chat',
    name: 'chat',
    component: chat,
    meta: {
      keepAlive: true // Cache required
    }
  },
  {
    path: '/privacy1',
    name: 'privacy1',
    component: privacy1,
    meta: {
      keepAlive: true // Cache required
    }
  },
  {
    path: '/privacy2',
    name: 'privacy2',
    component: privacy2,
    meta: {
      keepAlive: true // Cache required
    }
  },
  {
    path: '/privacy4',
    name: 'privacy4',
    component: privacy4,
    meta: {
      keepAlive: true // Cache required
    }
  },
  {
    path: '/version-check',
    name: 'versionCheck',
    component: versionCheck,
    meta: {
      keepAlive: false // Cache required
    }
  },
  {
    path: '/wishList',
    name: 'wishList',
    component: wishList,
    meta: {
      keepAlive: false // Cache required
    }
  },
  {
    path: '/sery',
    name: 'sery',
    component: sery,
    meta: {
      keepAlive: false // Cache required
    }
  }
]
const router = new Router({
  mode: 'history',
  routes
})
router.beforeEach((to, from, next) => {
  // console.log('beforeEach ::::: ', to.query.redirect === 'Y', 'to :::::', to, 'from :::::', from)
  if (to.query.redirect === 'Y') {
    next()
  } else {
    to.path !== from.path && next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js